// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2wpDa","options":"AnswerScale_options__2EqKH","selected":"AnswerScale_selected__FyIuz"};